import { z } from 'zod';
import { creditApi, getCurrentTenant } from '@/shared/http';
import { apiQuery, createQueryKeys } from '@/shared/data';
const text = z.string().nullish();
export const personForBillingSchema = z.looseObject({
  id: text,
  name: text.meta({ pii: 'name' }),
  registrationNumber: text.meta({ pii: 'document' }),
  email: text.meta({ pii: 'email' }),
  companyName: text.meta({ pii: 'name' }),
  address: z
    .looseObject({ zipCode: text, addressName: text, number: text, complement: text })
    .nullish()
    .meta({ pii: 'address' }),
});
export type PersonForBilling = z.output<typeof personForBillingSchema>;
export type PersonForBillingInput = { id: string; discriminator: 'NaturalPerson' | 'LegalPerson' };
/** Legacy personContext.tsx:192-218; CreditAPI detail has no tenant query. */
export async function getPersonForBilling(
  input: PersonForBillingInput,
  signal?: AbortSignal,
): Promise<PersonForBilling> {
  const data = await creditApi.get<unknown>(
    `/${input.discriminator}/${encodeURIComponent(input.id)}`,
    { ...(signal ? { signal } : {}) },
  );
  const parsed = personForBillingSchema.safeParse(data);
  if (parsed.success) return parsed.data;
  if (import.meta.env.DEV) console.warn('Person billing detail outside expected contract');
  return data as PersonForBilling;
}
const keys = createQueryKeys('person');
export function personForBillingQuery(input: PersonForBillingInput) {
  return apiQuery(
    keys.custom('billing-detail', { ...input, tenant: getCurrentTenant() }),
    ({ signal }) => getPersonForBilling(input, signal),
    { enabled: input.id !== '' },
  );
}
